import { buildQueryFields, getInheritedFilters, getQueryProps } from '../../../helpers';
import { getSearchPublishedContent } from '../../../application/query';

const filtersSetup = ({
  entityFields,
  entityTypes,
  filterBy,
  filterByProperty,
  entities,
  currentSchema,
  filterEntitySchema,
  isPreview,
  itemEntityUpdated,
  isFull
}) => {
  const fields = buildQueryFields(entityFields, entityTypes, isFull);
  const action = getSearchPublishedContent(fields);
  const inheritedFilters = getInheritedFilters(filterBy, filterByProperty);
  const entitySameAsCurrentItemEntity = entities.includes(itemEntityUpdated);
  const { relations: filterEntityRelations = [] } = filterEntitySchema;
  const queryProps = getQueryProps(inheritedFilters, currentSchema, filterEntitySchema);
  const { actions = {} } = currentSchema || {};
  const getAction = isPreview ? actions.get : actions.getPublished;

  return {
    getAction,
    queryProps,
    inheritedFilters,
    currentSchema,
    filterEntitySchema,
    entitySameAsCurrentItemEntity,
    action,
    filterEntityRelations
  };
};

export default filtersSetup;
